<template lang="pug">
div
	v-e24-nav-bar
	section.maincolumn-constrained
		form.login-form(name='form', novalidate v-on:submit.prevent="")
			.login-body
				h3 {{ $t('login.recoverPassTitle') }}
				//span {{ $t('login.recoverText') }}
				br
				.alert.alert-warning(v-if='authReason') {{authReason}}
				.alert.alert-danger(v-if='authError') {{authError}}

				.login-lbl
					label New Password
					input.login-field(name='login', type="password", v-model='user.password', required, autofocus, novalidate='')

				.login-lbl
					label {{ $t('user.confirmPass') }}
					input.login-field(name='login', type="password", v-model='user.confirmPass', required, autofocus, novalidate='')

				.btn-login-cnt
					b-button(variant="success", size="lg", @click='recover') {{ $t('label.ok') }}
					| &nbsp;
					b-button(variant="success", size="lg", @click="$router.push('login')") {{ $t('label.cancel') }}
	v-e24-footer(:build="build")

	md-snackbar(md-position='center', :md-duration='snackbar.duration', :md-active.sync='snackbar.show', md-persistent='')
		span {{ $t(snackbar.message) }}
		md-button.md-primary(@click='snackbar.show = false') {{ $t('label.ok') }}
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import _ from 'lodash'
// import md5 from 'md5'
import readBuild from '../../util/readBuild'

export default {
	name: 'ForgotPassword',
	data () {
		return {
			build: '',
			authError: '',
			authReason: '',
			searchToRecover: '',
			snackbar: { show: false, message: '', duration: 1000 },
			user: {},
			recObj: {},
			recovery: {}
		}
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	beforeRouteEnter (to, from, next) {
		Vue.jnx.userActionService.findByCode(to.params.code).then(function (invitation) {
			console.log('find invitation by code', to.params.code, invitation)
			next((vm) => {
				vm.recovery = invitation
				vm.init()
			})
			return invitation
		}, (err) => {
			next((vm) => {
				vm.infoDialog(this.$t('user.dialogs.invalidCode'))
				console.log('Error retriving recovery', err, to.params.code)
				this.$router.push({ name: 'forgot-password' })
			})
		})
	},
	methods: {
		...mapActions(['infoDialog']),

		init () {
			this.recObj = this.recovery
			console.log('recovery', this.recObj)

			if (_.isNil(this.recovery)) {
				this.infoDialog(this.$t('user.dialogs.invalidCode'))
			} else {
				const now = new Date()
				if (this.recObj.expire < now) {
					this.infoDialog(this.$t('user.dialogs.recoveryExpired'))
					this.$router.push({name: 'connect', params: {goodbye: '', redirect: ''}})
				} else if (this.recObj.status === 'completed') {
					this.infoDialog(this.$t('user.dialogs.recoveryPrevCompl'))
					this.$router.push({name: 'connect', params: {goodbye: '', redirect: ''}})
				} else {
					this.user = this.recObj.account
					this.user.password = ''
					this.user.confirmPass = ''
				}
			}
		},

		recover () {
			// Save recovery + account
			try {
				Vue.jnx.validationService.password(this.user.password, this.user.confirmPass)
			} catch (err) {
				switch (err.message) {
				case 'notMatch':
					this.infoDialog('user.dialogs.passConfMatch')
					return
				case 'strength':
					this.infoDialog('user.dialogs.passStrength')
					return
				}
			}

			const username = this.user.username
			const password = this.user.password

			this.recObj.status = 'completed'
			this.recObj.account = this.user
			// this.recObj.account.password = md5(this.recObj.account.password)
			Vue.jnx.userActionService.update(this.recObj).then(() => {
				// Try to login
				return Vue.e24.security.login(username, password)
			}).then((loggedIn) => {
				if (!loggedIn) {
					// If we get here then the login failed due to bad credentials
					this.authError = this.$t('login.error.invalidCredentials')
					this.authReason = null
				} else if (this.$route.name === 'recover') {
					this.$router.push('/')
				}
			}, () => {
				// If we get here then there was a problem with the login request to the server
				this.authError = this.$t('login.error.serverError')
				this.authReason = null
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/login/recover-password.vue